import type { Catalog } from "./en";

export const nl: Catalog = {
  "common.retry": "Opnieuw proberen",
  "common.reload": "Herladen",
  "common.save": "Opslaan",
  "common.saving": "Opslaan…",
  "common.saved": "Opgeslagen",
  "common.saveFailed": "Opslaan mislukt",
  "common.saveChanges": "Wijzigingen opslaan",
  "common.delete": "Verwijderen",
  "common.remove": "Verwijderen",
  "common.cancel": "Annuleren",
  "common.edit": "Bewerken",
  "common.openLink": "Openen",
  "common.back": "← Terug",
  "common.loading": "Laden",
  "common.loadingMore": "Laden…",
  "common.sending": "Versturen…",
  "common.error": "Er ging iets mis",
  "common.failed": "Mislukt",
  "common.name": "Naam",
  "common.email": "E-mail",
  "common.title": "Titel",
  "common.language": "Taal",

  "time.now": "nu",
  "time.lessThanMinute": "<1 min",
  "time.minutes": "{n} min",
  "time.hours": "{n} u",
  "time.days": "{n} d",

  "nav.inbox": "Inbox",
  "nav.faq": "Helpcentrum",
  "nav.reports": "Rapporten",
  "nav.settings": "Instellingen",
  "layout.workspace": "Werkruimte",
  "layout.newWorkspace": "+ Nieuwe werkruimte",
  "layout.signOut": "Afmelden",

  "app.unreachable.title": "Kan de server niet bereiken",
  "app.unreachable.body": "Controleer je verbinding en probeer het opnieuw.",
  "app.noWorkspaces.title": "Nog geen werkruimtes",
  "app.noWorkspaces.body": "Vraag een beheerder om je voor een werkruimte uit te nodigen.",

  "error.pane": "Dit gesprek kan niet worden weergegeven.",
  "error.tryAgain": "Opnieuw proberen",
  "error.body": "Er is een onverwachte fout opgetreden op dit scherm.",
  "error.goInbox": "Naar de inbox",

  "login.title": "Aanmelden bij Support",
  "login.sent": "Als {email} toegang heeft, is er een aanmeldlink onderweg. Die verloopt over 15 minuten.",
  "login.intro": "We mailen je een eenmalige aanmeldlink.",
  "login.email": "Zakelijk e-mailadres",
  "login.sendFailed": "De link kon niet worden verstuurd. Probeer het over een minuut opnieuw.",
  "login.submit": "Mail me een link",
  "verify.incomplete": "Deze link is onvolledig.",
  "verify.failed": "Aanmelden mislukt.",
  "verify.expired": "Link verlopen",
  "verify.signingIn": "Je wordt aangemeld…",
  "verify.newLink": "Nieuwe link aanvragen",

  "newWs.superAdminOnly": "Alleen superbeheerders kunnen werkruimtes aanmaken.",
  "newWs.created": "Werkruimte aangemaakt",
  "newWs.copySecret": "Kopieer het identiteitsgeheim nu. Het wordt maar één keer getoond (je kunt het later vernieuwen).",
  "newWs.secretLabel": "Identiteitsgeheim (alleen server)",
  "newWs.continue": "Verder naar installatie",
  "newWs.createFailed": "Werkruimte kon niet worden aangemaakt",
  "newWs.title": "Nieuwe werkruimte",
  "newWs.intro": "Eén werkruimte per app of product. Elke werkruimte heeft een eigen helpcentrum, inbox en sleutels.",
  "newWs.submit": "Werkruimte aanmaken",

  "reports.period": "Periode",
  "reports.lastDays": "Laatste {count} dagen",
  "reports.loadFailed": "Het rapport kon niet worden geladen.",
  "reports.conversations": "Gesprekken",
  "reports.resolved": "Opgelost",
  "reports.medianReply": "Mediaan eerste antwoord",
  "reports.satisfaction": "Tevredenheid",
  "reports.ratingsCount": "{count} beoordelingen",
  "reports.ratingsCount.one": "{count} beoordeling",
  "reports.ratingsCount.other": "{count} beoordelingen",
  "reports.ratings": "Beoordelingen",
  "reports.barLabel": "{count} beoordelingen van {score}",
  "reports.barLabel.one": "{count} beoordeling van {score}",
  "reports.barLabel.other": "{count} beoordelingen van {score}",
  "reports.recentComments": "Recente opmerkingen",
  "reports.noComments": "Nog geen opmerkingen.",

  "status.open": "Open",
  "status.pending": "In afwachting",
  "status.resolved": "Opgelost",

  "inbox.title": "Support-inbox",
  "inbox.conversations": "Gesprekken",
  "inbox.liveStopped": "Live-updates gestopt.",
  "inbox.notifyPrompt": "Krijg een bureaubladmelding bij nieuwe berichten.",
  "inbox.enableNotifications": "Meldingen inschakelen",
  "inbox.notNow": "Niet nu",
  "inbox.statusFilter": "Status",
  "inbox.assignee": "Toegewezen aan",
  "inbox.all": "Alle",
  "inbox.mine": "Van mij",
  "inbox.unassigned": "Niet toegewezen",
  "inbox.loadFailed": "Gesprekken konden niet worden geladen.",
  "inbox.empty.open": "Geen open gesprekken 🎉",
  "inbox.empty.pending": "Geen gesprekken in afwachting 🎉",
  "inbox.empty.resolved": "Geen opgeloste gesprekken 🎉",
  "inbox.you": "Jij",
  "inbox.agent": "Medewerker",
  "inbox.attachment": "📎 Bijlage",
  "inbox.unreadCount": "{count} ongelezen",
  "inbox.loadMoreFailed": "Meer gesprekken konden niet worden geladen",
  "inbox.loadMore": "Meer laden",
  "inbox.select": "Kies een gesprek",
  "inbox.visitor": "Bezoeker {id}",

  "contact.aria": "Contact",
  "contact.verified": "✓ Geverifieerde gebruiker",
  "contact.anonymous": "Anonieme bezoeker",
  "contact.userId": "Gebruikers-ID",
  "contact.lastSeen": "Laatst gezien",
  "contact.started": "Gestart",
  "contact.rating": "Beoordeling",

  "event.resolved": "opgelost",
  "event.reopened": "heropend",
  "event.assigned": "toegewezen",
  "event.csat_request": "beoordeling gevraagd",
  "event.auto_reply": "automatisch antwoord",

  "sys.resolved": "Gemarkeerd als opgelost",
  "sys.reopened": "Heropend",
  "sys.assigned": "Toegewezen aan {name}",
  "sys.csat_request": "Beoordeling gevraagd",
  "sys.auto_reply": "Automatisch antwoord: {body}",

  "thread.aria": "Gesprek",
  "thread.verified": "Geverifieerde gebruiker",
  "thread.you": "{name} (jij)",
  "thread.reopen": "Heropenen",
  "thread.snooze": "Uitstellen",
  "thread.snoozeTitle": "Wacht op de klant",
  "thread.resolve": "Oplossen",
  "thread.liveStopped": "Live-updates voor dit gesprek gestopt.",
  "thread.loadFailed": "Dit gesprek kon niet worden geladen.",
  "thread.loadEarlier": "Eerdere laden",
  "thread.loadEarlierFailed": "Eerdere berichten konden niet worden geladen",
  "thread.failedRetry": "Mislukt – opnieuw proberen",
  "thread.typing": "{name} is aan het typen…",
  "thread.seen": "Gezien",
  "thread.updateFailed": "Bijwerken mislukt",

  "composer.uploadFailed": "Uploaden mislukt",
  "composer.savedReplies": "Opgeslagen antwoorden",
  "composer.placeholder": "Antwoord aan {name}… (typ / voor opgeslagen antwoorden)",
  "composer.reply": "Antwoord",
  "composer.attach": "📎 Bijvoegen",
  "composer.uploading": "Uploaden…",
  "composer.removeFile": "{name} verwijderen",
  "composer.send": "Versturen",

  "faq.untitled": "(zonder titel)",
  "faq.loadFailed": "Het helpcentrum kon niet worden geladen.",
  "faq.loadFailedToast": "Het helpcentrum kon niet worden geladen",
  "faq.notFound": "Artikel niet gevonden.",
  "faq.backToList": "Terug naar het helpcentrum",
  "faq.intro": "Artikelen verschijnen in het helpcentrum in de app en worden voorgesteld voordat klanten een chat starten.",
  "faq.newArticle": "Nieuw artikel",
  "faq.categories": "Categorieën",
  "faq.categoriesIntro": "Groepeer artikelen per onderwerp. Titels zijn per taal.",
  "faq.addCategoryFailed": "Categorie kon niet worden toegevoegd",
  "faq.newCategoryPlaceholder": "Titel nieuwe categorie ({locale})",
  "faq.addCategory": "Categorie toevoegen",
  "faq.noArticles": "Nog geen artikelen. Begin met je meest gestelde vraag.",
  "faq.uncategorized": "Zonder categorie",
  "faq.languages": "Talen",
  "faq.views": "Weergaven",
  "faq.helpful": "Nuttig",
  "faq.helpfulValue": "{percent}% van {votes}",
  "faq.published": "Gepubliceerd",
  "faq.draft": "Concept",
  "faq.missing": "Ontbreekt",
  "faq.categoryTitle": "Titel ({locale})",
  "faq.saveCategoryFailed": "Categorie kon niet worden opgeslagen",
  "faq.categorySaved": "Categorie opgeslagen",
  "faq.deleteCategoryConfirm": "Deze categorie verwijderen? De artikelen worden dan zonder categorie.",
  "faq.deleteCategoryFailed": "Categorie kon niet worden verwijderd",
  "faq.addTitleFirst": "Voeg eerst een titel toe",
  "faq.deleteArticleConfirm": "Dit artikel in alle talen verwijderen?",
  "faq.deleteArticleFailed": "Artikel kon niet worden verwijderd",
  "faq.category": "Categorie",
  "faq.titlePlaceholder": "Hoe kan ik…?",
  "faq.untitledExisting": "Voeg een titel toe voor {locale}, of verwijder hieronder de {locale}-vertaling.",
  "faq.untitledNew": "Voeg een titel toe voor {locale}, of maak de tekst leeg om deze taal weg te laten.",
  "faq.slug": "URL-slug",
  "faq.slugHint": "Laat leeg om hem uit de titel te maken.",
  "faq.body": "Tekst (Markdown)",
  "faq.bodyHint": "Ondersteunt **vet**, *cursief*, lijsten, links, afbeeldingen en `code`. HTML wordt als tekst getoond.",
  "faq.publishedIn": "Gepubliceerd in {locale}",
  "faq.removeTranslation": "{locale}-vertaling verwijderen",
  "faq.preview": "Voorbeeld",
  "faq.untitledPreview": "Zonder titel",

  "settings.tab.general": "Algemeen",
  "settings.tab.hours": "Openingstijden",
  "settings.tab.install": "Installatie",
  "settings.tab.push": "Pushmeldingen",
  "settings.tab.team": "Team",
  "settings.tab.canned": "Opgeslagen antwoorden",
  "settings.adminOnly": "Alleen beheerders van de werkruimte kunnen deze instellingen wijzigen.",
  "settings.loadFailed": "Instellingen konden niet worden geladen.",
  "settings.reloadFailed": "Instellingen konden niet opnieuw worden geladen",

  "general.branding": "Huisstijl",
  "general.brandingIntro": "Hoe het helpcentrum en de chat eruitzien in je app.",
  "general.brandColor": "Merkkleur",
  "general.brandColorPicker": "Merkkleur kiezen",
  "general.brandColorHex": "Merkkleur in hex",
  "general.logoUrl": "Logo-URL",
  "general.logoHint": "HTTPS-afbeelding bovenaan het helpcentrum.",
  "general.languages": "Talen",
  "general.languagesIntro": "De interface volgt de taal van het toestel als die hier aan staat; artikelen vallen terug op de standaardtaal.",
  "general.defaultLanguage": "Standaardtaal",
  "general.greeting": "Begroeting ({locale})",
  "general.greetingHint": "Laat leeg om de ingebouwde begroeting te gebruiken.",
  "general.csatTitle": "Tevredenheidsbeoordelingen",
  "general.csatAsk": "Klanten vragen het gesprek te beoordelen als het is opgelost",

  "hours.intro": "Buiten deze tijden zien klanten dat je afwezig bent en krijgen ze je automatische antwoord.",
  "hours.enable": "Openingstijden gebruiken (anders sta je altijd online)",
  "hours.timezone": "Tijdzone",
  "hours.open": "Open",
  "hours.closed": "Gesloten",
  "hours.opens": "{day} opent",
  "hours.closes": "{day} sluit",
  "hours.replyTitle": "Reactietijd & automatisch antwoord",
  "hours.typical": "Gebruikelijke reactietijd (minuten)",
  "hours.typicalHint": "Wordt aan klanten getoond terwijl je online bent. Laat leeg om te verbergen.",
  "hours.away": "Afwezigheidsbericht ({locale})",
  "hours.awayHint": "Wordt automatisch verstuurd als iemand buiten de openingstijden schrijft (maximaal één keer per 12 u per gesprek).",

  "install.keys": "Sleutels",
  "install.publishableKey": "Publieke sleutel",
  "install.publishableHint": "Veilig om mee te leveren in je app en website.",
  "install.identitySecret": "Identiteitsgeheim",
  "install.secretHint": "Bewaar dit op je server. Gebruik het om gebruikers-ID's te ondertekenen, zodat chats aan ingelogde gebruikers gekoppeld zijn.",
  "install.secretHidden": "Verborgen. Vernieuwen maakt bestaande gebruikershashes meteen ongeldig.",
  "install.rotateConfirm": "Het identiteitsgeheim vernieuwen? Je server moet meteen het nieuwe geheim gebruiken.",
  "install.rotateFailed": "Het geheim kon niet worden vernieuwd",
  "install.rotate": "Geheim vernieuwen",
  "install.origins": "Toegestane websites",
  "install.originsIntro": "Origins die de webwidget mogen gebruiken (één per regel, bv. https://app.example.com). Gebruik * om alles toe te staan. Mobiele apps hebben dit niet nodig.",
  "install.saveOrigins": "Origins opslaan",
  "install.reactWeb": "React (web)",
  "install.anyWebsite": "Elke website",
  "install.verifyUsers": "Gebruikers verifiëren (op de server)",
  "install.verifyIntro": "Bereken de gebruikershash op je server en geef die mee met het gebruikers-ID.",

  "push.fcmTitle": "Android (Firebase Cloud Messaging)",
  "push.fcmIntro": "Upload een JSON van een Firebase-serviceaccount met de Cloud Messaging-machtiging.",
  "push.fcmFile": "JSON van Firebase-serviceaccount",
  "push.saveFcm": "FCM-gegevens opslaan",
  "push.apnsTitle": "iOS (Apple Push Notification service)",
  "push.apnsIntro": "Maak een APNs-authenticatiesleutel (.p8) aan in je Apple-ontwikkelaarsaccount.",
  "push.p8File": ".p8-sleutelbestand",
  "push.keyId": "Sleutel-ID",
  "push.teamId": "Team-ID",
  "push.saveApns": "APNs-gegevens opslaan",
  "push.configured": "Ingesteld op {date}",
  "push.notConfigured": "Niet ingesteld",

  "team.invite": "Teamlid uitnodigen",
  "team.inviteIntro": "Die persoon krijgt een e-mail met een aanmeldlink.",
  "team.role": "Rol",
  "team.role.agent": "Medewerker",
  "team.role.admin": "Beheerder",
  "team.sendInvite": "Uitnodiging versturen",
  "team.inviteSent": "Uitnodiging verstuurd",
  "team.inviteNoEmail": "Toegevoegd. Geen e-mail verstuurd: dit adres kreeg onlangs al meerdere aanmeldmails. Die persoon kan een daarvan gebruiken.",
  "team.inviteFailed": "Uitnodigen mislukt",
  "team.members": "Leden",
  "team.loadFailed": "Leden konden niet worden geladen.",
  "team.loadFailedToast": "Leden konden niet worden geladen",
  "team.online": "online",
  "team.removeConfirm": "{name} verwijderen? De gesprekken van die persoon worden dan niet meer toegewezen.",
  "team.removeFailed": "Lid kon niet worden verwijderd",

  "canned.intro": "Typ {shortcut} in het antwoordveld om er een in te voegen. Gebruik {name} voor de voornaam van de klant en {agent} voor die van jou.",
  "canned.shortcut": "Snelkoppeling",
  "canned.shortcutHint": "kleine letters, cijfers, streepjes",
  "canned.message": "Bericht",
  "canned.empty": "Nog geen opgeslagen antwoorden. Maak er een en typ dan de /snelkoppeling in het antwoordveld om het in te voegen.",
  "canned.new": "Nieuw opgeslagen antwoord",
  "canned.deleteConfirm": "Opgeslagen antwoord /{shortcut} verwijderen?",
  "canned.deleteFailed": "Opgeslagen antwoord kon niet worden verwijderd",
  "canned.loadFailed": "Opgeslagen antwoorden konden niet worden geladen.",
  "canned.loadFailedToast": "Opgeslagen antwoorden konden niet worden geladen",
};
